import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ElementBaseModel from './base-modeles/element-base-model';
import ConvertEngine from './convert/convertEngine';
import { getSmartArtElementModelConstructorByType } from './factories/smartart-element-model-factory';
import _isEqual from 'lodash/isEqual';
import _set from 'lodash/set';
import { observable } from 'mobx';
import { ISmartArtModelProps } from './Interface/model-props/smart-art-model-props.interface';
import { ISmartArtModel } from '@src/slide/domain/ui-model/element-modeles/Interface/smart-art-model.interface';
import { ISmartArtDataModel } from '@tencent/slide-sdk-model';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { IGroupFrameProperty } from './property/frame/group/index.interface';
import SmartArtFrame from './property/frame/group/smart-art-frame';
import ModelConverterBridge from '@src/slide/domain/ui-model/element-modeles/convert/model-converter-bridge';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';

class SmartArtModel extends ElementBaseModel implements ISmartArtModel {
    public static convertDataUiToSdk(uiData, sdkData, rawUiData) {
        ModelConverterBridge.convertUiToSdk({ type: UIModelType.SMART_ART, uiData, sdkData, rawUiData });
    }

    public static async convertDataSdkToUi(sdkData, uiData, rawSdkData, option?) {
        if (_isEqual(uiData, {})) return;
        if (!sdkData) {
            return;
        }
        super.convertDataSdkToUi(sdkData, uiData, rawSdkData, option);

        const convertPromises: Array<Promise<any> | IBaseModel> = [];
        const convertSmartArtTask = ModelConverterBridge.convertSdkToUi({
            type: UIModelType.SMART_ART,
            sdkData,
            uiData,
        });
        convertPromises.push(convertSmartArtTask);

        if (sdkData?.shapeList && sdkData?.shapeList.length > 0) {
            const convertChildrenPromise = ConvertEngine.convertArrayDataSdkToUi(
                getSmartArtElementModelConstructorByType,
                rawSdkData.shapeList,
                uiData.shapeList,
                uiData,
                option,
            );
            convertPromises.push(convertChildrenPromise);
        }

        if (uiData.parent?.asyncConvertChildren) {
            await Promise.all(convertPromises);
            _set(uiData, 'asyncConvertChildren', false);
        }
    }

    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据recursion
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject) {
        super.didConvertDataSdkToUi(sdkData, uiData, rawSdkData, optionObject);

        const resetFrameRecursion = (smartArt) => {
            smartArt.shapeList.forEach((item) => {
                item.resetFrame();
            });
        };

        resetFrameRecursion(uiData);
    }

    declare public props: ISmartArtModelProps;
    public sdkData: ISmartArtDataModel | null = null;
    public shapeList: Array<IElementBaseModel> = [];
    @observable public refreshGroupByChildrenWithoutChangeSet = 0;
    public groupChildFrameChangedByChildren: any;
    public childResizeFinished = false;  // 标志子元素缩放结束
    public isRootSmartArt = true;
    private smartArtFrameInstance: IGroupFrameProperty;

    public constructor(props?: {}) {
        super(props);
        this.type = UIModelType.SMART_ART;
        this.props.childFrame = { left: 0, top: 0, width: 0, height: 0 };
    }

    public unbindSDK() {
        super.unbindSDK();
        // GroupRefreshMenu.removeRefreshGroupItemValues(this);
        for (let i = 0; i < this.shapeList.length; i++) {
            this.shapeList[i]?.unbindSDK();
        }
    }

    public get scaleX() {
        const childWidth = this.sdkData?.props?.spPr?.xfrm?.ext?.cx;
        if (this.sdkData?.props?.spPr?.xfrm?.ext?.cx !== undefined
            && childWidth !== undefined && childWidth > 0) {
            return this.sdkData?.props?.spPr?.xfrm?.ext?.cx / childWidth;
        }
        return 1.0;
    }

    public get scaleY() {
        const childHeight = this.sdkData?.props?.spPr?.xfrm?.ext?.cy;
        if (this.sdkData?.props?.spPr?.xfrm?.ext?.cy !== undefined
            && childHeight !== undefined && childHeight > 0) {
            return this.sdkData?.props?.spPr?.xfrm?.ext?.cy / childHeight;
        }
        return 1.0;
    }

    public getFrame(): IGroupFrameProperty {
        if (!this.smartArtFrameInstance) {
            this.smartArtFrameInstance = new SmartArtFrame(this);
        }
        return this.smartArtFrameInstance;
    }

    // public async sdkOnDidChange(sdkData, changeSet, valueObject) {
    //     const dataTemplate = {
    //         props: null,
    //     };
    //     this.changeSetEngine.visualize(changeSet, dataTemplate);
    //     await super.sdkOnDidChange(sdkData, changeSet, valueObject);
    // }
}

export default SmartArtModel;
